import React, { useState, useCallback, useEffect, useRef } from 'react'
import gsap from 'gsap'

//* Components
import Logo from './Logo'
import MenuItems from 'components/common/MenuItems'
import AnimationWrap from 'components/common/AnimationWrap'
import LottieAnimation from 'components/common/LottieAnimation'
import HeaderCartAccount from './HeaderCartAccount'
import BurgerMenu from './BurgerMenu'

//* Style
import Header from './style'
import { withUIContext } from 'context'

//* Lottie
import burgerMenuLottie from 'lottieAnimation/burgerMenuLottie.json'

const AppHeader = ({ winWidth, isBurgerMenuOpen, toggleBurgerMenu }) => {
    //! Checkers
    const isMobile = winWidth < 768

    //! States
    const [secObj, setSecObj] = useState()

    //! Refs
    const items = useRef([])
    const headerRef = useRef()

    useEffect(() => {
        if (items?.current) {
            setSecObj([items.current])
        }
    }, [items, winWidth])

    const slideDown = (arr) => {
        gsap.to(arr, {
            y: '0%',
            stagger: 0.1,
        })
    }

    const startAnimeArr = useCallback((x) => {
        const headerHeight = document.querySelector('header').getBoundingClientRect().height
        document.querySelector('.min-height').style['min-height'] = `calc(100vh - ${headerHeight}px)`

        if (x) {
            slideDown([headerRef.current], 0.2)
        }
    }, [])

    return (
        <>
            <Header ref={headerRef} className='FlexBox alignMiddle'>
                <AnimationWrap state={secObj} startAnimeArr={startAnimeArr}>
                    <Logo />
                    {!isMobile && <MenuItems />}
                    <HeaderCartAccount />
                    {isMobile && (
                        <div onClick={() => toggleBurgerMenu()} className='burgerMenuIcon'>
                            <LottieAnimation
                                animData={burgerMenuLottie}
                                autoplay={false}
                                isPlay={isBurgerMenuOpen}
                                isReverse={!isBurgerMenuOpen}
                                loop={false}
                            />
                        </div>
                    )}
                </AnimationWrap>
            </Header>
            {isMobile && <BurgerMenu />}
        </>
    )
}

export default withUIContext(AppHeader, ['winWidth', 'isBurgerMenuOpen', 'toggleBurgerMenu'])
